import React from "react";
import styled, { css } from "styled-components";
import { THEME_COLORS } from "../../../ThemeConfig";

// Icons
import plusIcon from "../../../assets/image/icons/plus-white.svg";
import editIcon from "../../../assets/image/icons/edit.svg";
import deleteIcon from "../../../assets/image/icons/delete.svg";
import importIcon from "../../../assets/image/icons/import.svg";
import exportIcon from "../../../assets/image/icons/export.svg";

const variantStyles = {
  create: {
    bg: "#366ee3",
    color: THEME_COLORS.white,
    icon: plusIcon,
  },
  create_red: {
    bg: "#FE6666",
    color: THEME_COLORS.white,
    icon: plusIcon,
  },
  create_black:{
    bg: "#000000",
    color: THEME_COLORS.white,
    icon: plusIcon,
  },
  edit: {
    bg: "#ff9800",
    color: THEME_COLORS.white,
    icon: editIcon,
  },
  delete: {
    bg: "#FE6666",
    color: THEME_COLORS.white,
    icon: deleteIcon,
  },
  import: {
    bg: "#009688",
    color: THEME_COLORS.white,
    icon: importIcon,
  },
  import_black: {
    bg: "#000000",
    color: THEME_COLORS.white,
    icon: importIcon,
  },
  export: {
    bg: "#673ab7",
    color: THEME_COLORS.white,
    icon: exportIcon,
  },
};

const ActionButton = ({ variant = "create", label, onClick }) => {
  const { bg, color, icon } = variantStyles[variant] || variantStyles.create;

  return (
    <Button bg={bg} color={color} onClick={onClick}>
      {icon && <img src={icon} alt={`${variant} icon`} />}
      {label}
    </Button>
  );
};

export default ActionButton;

/* Styles */
const Button = styled.button`
  padding: 8px 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: "DM_sans_medium";
  border: none;
  transition: all 0.2s ease;

  ${({ bg, color }) => css`
    background: ${bg};
    color: ${color};
  `}

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  img {
    width: 16px;
    height: 16px;
  }
`;
